import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentSigningComponent } from "./components/document-signing/document-signing.component";
import { DocumentPendingComponent } from './components/document-pending/document-pending.component';
const routes: Routes = [
    {path: '', loadChildren: () => import('./components/home/home-routing.module').then(m => m.HomeRoutingModule) },
    {path: 'documentos', component: DocumentSigningComponent},
    {path: 'pendientes', component: DocumentPendingComponent},
    {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
